import styled from 'styled-components';

const data = [
  {
    time: '14:00 - 14:05',
    duration: '5분',
    title: '개회사 및 플랫폼 소개',
    desc: '엔플랫폼 대표 인사말・오픈배경・비전 공유',
  },
  {
    time: '14:05 - 14:50',
    duration: '45분',
    title: '국내 NPL 통계 및 최근 NPL 소개',
    check: [
      {
        title: '국내 NPL 거래 통계',
        item: [
          '경매 건수 추이',
          '낙찰률 변화 및 회수율 통계',
          '투자자참여 기관별 비중(은행, 저축은행, 신협 등)',
        ],
      },
      {
        title: '국내 NPL 시장 구조',
        item: [
          '은행, 저축은행, 신협 등 주요 매각 주체별 점유율을 최근 시장 동향',
          '부동산 경기 침체로 증가하는 부실채권 규모',
          '대출 기관(증권사, 운용사)의 신규 시장 참여 증가 분석',
        ],
      },
      {
        title: '리스크 인사이트',
        item: [
          '투자 위험요인 3가지: 지역 경기, 채무자 특성, 법적 분쟁 요소',
          '실거래 데이터 기반으로 제시하여 스마트한 투자 의사결정 지원',
        ],
      },
    ],
  },
  {
    time: '14:50 - 15:40',
    duration: '50분',
    title: '플랫폼 서비스 및 사용방법 소개',
    desc: '',
    check: [
      {
        title: 'AI 자동화 프로세스 시연',
        item: [
          '문서 자동처리 (OCR + LLM) 등기부·건축물대장 자동',
          '분류 및 데이터 업로드 → 자동 추출 & 표준화',
        ],
      },
      {
        title: 'AI Agent 추천',
        item: [
          '투자자가 조건입력 → 축시 최적의 매물 추천',
          '매물별 리스크 요인, 예상 낙찰가 범위 한 눈에 제시',
        ],
      },
      {
        title: '실시간 낙찰가・낙찰률 계산',
        item: [
          '경·공매 진행 낙찰가・낙찰률 기반 시세 측 계산',
          'AI가 유사 거래 DB와 머신러닝 기반 시뮬레이션 수행',
        ],
      },
    ],
  },
  {
    time: '15:40 - 16:00',
    duration: '20분',
    title: '현장 네트워킹',
    desc: '현장 질의응답, 네트워킹 세션',
  },
];

function Curriculum() {
  return (
    <Container>
      {data.map((s, idx) => (
        <>
          <Section key={idx}>
            <Left>
              <Time>{s.time}</Time>
              <Duration>
                <img src="/assets/images/icon/time-skyblue.svg" alt="" />
                {s.duration}
              </Duration>
            </Left>
            <Right>
              <Title>{s.title}</Title>
              <DescSection>
                {s.desc && <Desc>{s.desc}</Desc>}
                {s.check &&
                  s.check.map((checkItem, i) => (
                    <CheckSection key={i}>
                      <CheckTitle>
                        {checkItem.title}
                        {checkItem.item.map((item) => (
                          <CheckItem key={item}>
                            <Check>
                              <img
                                src="/assets/images/check/check-skyblue.svg"
                                alt=""
                              />
                            </Check>
                            {item}
                          </CheckItem>
                        ))}
                      </CheckTitle>
                    </CheckSection>
                  ))}
              </DescSection>
            </Right>
          </Section>
          {idx !== data.length - 1 && <Divider />}
        </>
      ))}
    </Container>
  );
}

export default Curriculum;

const Container = styled.div`
  display: flex;
  padding: 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #416368;
  background: #042b2e;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  background: #416368;
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

const Time = styled.div`
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
`;

const Duration = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  color: #b8ced0;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const Title = styled.div`
  color: #f2ffff;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
`;

const Desc = styled.div`
  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
`;

const DescSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const CheckSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
`;

const CheckTitle = styled.div`
  color: #28feff;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 145%; /* 23.2px */
`;

const CheckItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  color: #f2ffff;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
`;

const Check = styled.div`
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
